import React from 'react';
import PropTypes from 'prop-types';
import ButtonBase from '@material-ui/core/ButtonBase';

import VisuallyHidden from '../VisuallyHidden/VisuallyHidden';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

function ActionButton(props) {
  const {
    classes,
    icon,
    label,
    action,
    labelHidden,
    withBorder,
    wrapContainer,
    withPadding,
    small,
  } = props;
  const Icon = icon;

  let classNames = classes.root;
  if (withBorder) {
    classNames += ` ${classes.withBorder}`;
  }
  if (withPadding) {
    classNames += ` ${classes.withPadding}`;
  }
  if (small) {
    classNames += ` ${classes.small}`;
  }

  const button = (
    <ButtonBase className={classNames} onClick={action}>
      {labelHidden ? (
        <VisuallyHidden body={label} />
      ) : (
        <span className={classes.label}>{label}</span>
      )}
      <Icon className={classes.icon} />
    </ButtonBase>
  );

  return wrapContainer ? (
    <div className={classes.container}>{button}</div>
  ) : (
    button
  );
}

ActionButton.propTypes = {
  classes: PropTypes.object.isRequired,
  icon: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  action: PropTypes.func.isRequired,
  labelHidden: PropTypes.bool,
  wrapContainer: PropTypes.bool,
  withBorder: PropTypes.bool,
  withPadding: PropTypes.bool,
  small: PropTypes.bool,
};

ActionButton.defaultProps = {
  labelHidden: true,
  wrapContainer: false,
  withBorder: false,
  withPadding: false,
  small: false,
};

export default withStyles(styles)(ActionButton);
